import { skipToken, useQuery } from "@tanstack/react-query";

import type { ThrowOnError } from "../../providers/queryClient";
import { compilationQuery } from "../queries";

export function useCompilation(
  compilationId: string | null,
  extra: { throwOnError?: ThrowOnError } = {},
) {
  const options = compilationQuery(compilationId ?? "");
  return useQuery({
    ...options,
    queryFn: compilationId ? options.queryFn : skipToken,
    ...extra,
  });
}
